import script from "./WelcomeScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeScreen.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeScreen.vue?vue&type=style&index=0&id=056732ad&scoped=true&lang=scss"

import exportComponent from "/tmp/plasty-fe-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056732ad"]])

export default __exports__